import { useMatchMedia } from "shared/UI/Hooks/useMatchMedia";
import { ResponsiveBreakpoints } from "shared/UI/ResponsiveBreakpoints";
import { useMobilePlatform } from "core/hooks/useMobilePlatform";
import { DesktopAudioPlayer } from "./DesktopAudioPlayer/DesktopAudioPlayer";
import { NativeAudioPlayerPopup } from "./NativeAudioPlayerPopup/NativeAudioPlayerPopup";
import { WebAudioPlayerPopup } from "./WebAudioPlayerPopup/WebAudioPlayerPopup";
import { AudioPlayerResource } from "../../enums/types";

export type AudioPlayerProps = {
  resource: AudioPlayerResource;
  onClose: () => void;
  onDone: () => void;
};

export const AudioPlayer = ({ resource, onClose, onDone }: AudioPlayerProps) => {
  const isDesktop = useMatchMedia(ResponsiveBreakpoints.Desktop);
  const { isMobileApp } = useMobilePlatform();

  if (isDesktop) {
    return <DesktopAudioPlayer resource={resource} onDone={onDone} />;
  }

  return isMobileApp ? (
    <NativeAudioPlayerPopup resource={resource} onClose={onClose} onDone={onDone} />
  ) : (
    <WebAudioPlayerPopup resource={resource} onClose={onClose} onDone={onDone} />
  );
};
